/**
 * 登入頁（v2.39.x 定案）：
 *   - 卡片「疊層」：主卡後面墊一張略暗略大的底卡
 *   - 背景「光暈」：卡片正後方一圈柔光（Brad 從七款背景裡選的；
 *     它是唯一有漸層的一款，他看過並指定，不算違反「少漸層」）
 *   - header = 品牌名「聯盟營運後臺」+ 版本號（公開的 /api 回的）；content = 表單，沒有副標
 *
 * 規矩（Brad）：不提平台、不放圖、不放撲克元素、不要左側 bar。
 * 其他候選（卡片五款、背景七款）已拆掉，要看去 git history。
 */
import React from 'react';
import LoginFields from './LoginFields';
import { BRAND } from './brand';

export default function LoginCard({ version, ...form }) {
  return (
    <div className="lv-root">
      <div className="lv-bg" aria-hidden="true" />
      <div className="lv-center">
        <div className="lv-stack">
          <div className="lv-stack-back" aria-hidden="true" />
          <div className="lv-card">
            <div className="lv-card-head">
              <span className="lv-card-brand">{BRAND.name}</span>
              <span className="lv-card-ver" aria-label="版本">{version ? `v${version}` : ''}</span>
            </div>
            <div className="lv-card-body">
              <LoginFields {...form} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
